import {ClientInterviewQuestionnaireCompetenceRateModel} from './client-interview-questionnaire-competence-rate.model';

export class ClientInterviewQuestionnaireModel {
  referenceNumber: string;
  jobOrderNumber: string;
  jobOrderClient: string;
  jobOrderDescription: string;
  offeredSalary: number;
  offeredSalaryType: number;
  offeredSalaryMode: number;
  competenceRates: ClientInterviewQuestionnaireCompetenceRateModel[] = [];
  softSkillsRate: number;
  comments: string;
  interviewDate: string;
  generalCandidateRate: number;
  statusType: number;
  refusalReason: string;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/client-interview-questionnaire/client-interview-questionnaire.model.ts